import { Avatar, Box, Typography, useMediaQuery } from '@mui/material';
import { FiLink } from 'react-icons/fi';
import { getFirstLetters } from '../../Helpers/helper';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  customAvatar: {
    background: '#F6F8FB',
    color: '#0F0E1F',
    fontSize: '12px',
    height: '34px',
    width: '34px',
    fontWeight: '600',
  },
  linkBg: {
    background: '#0A66C2',
    height: '16px',
    width: '16px',
    borderRadius: '4px',
    cursor: "pointer"
  },
}));

const FounderTeam: React.FunctionComponent<any> = ({ founderTeam = [] }) => {
  const isMobilescreen = useMediaQuery('(max-width:600px)');
  const isMaxScreen = useMediaQuery('(min-width:1920px)');
  const classes = useStyles();

  return (
    <div
      style={{
        display: 'grid',
        gap: isMobilescreen ? '10px' : '20px',
        padding: isMobilescreen ? '0px' : isMaxScreen ? '0px 30px' : '0px 20px',
        gridTemplateColumns: isMobilescreen ? '1fr 1fr' : '1fr 1fr 1fr 1fr 1fr 1fr',
      }}
    >
      {founderTeam.map((items: any, index: number) => {
        return (
          <Box component={'div'} className="d-flex align-items-start justify-content-between" border={'1px solid #F2EDFD'} borderRadius={'6px'} bgcolor={'white'} sx={{ padding: '6px' }} key={index}>
            <Box component={'div'} className="d-flex align-items-center" gap={'8px'} padding={'6px'}>
              <Avatar className={classes.customAvatar}>{items?.Name ? getFirstLetters(items?.Name) : '-'}</Avatar>
              <Box component={'div'} className="d-flex flex-column" gap={'0px'}>
                <Typography fontSize={isMobilescreen ? '14px' : isMaxScreen ? '18px' : '12px'} fontWeight={'600'} color={'#0F0E1F'}>
                  {items?.Name}
                </Typography>
                <Typography fontSize={isMaxScreen ? '16px' : '12px'} fontWeight={'400'} color={'#00000099'}>
                  {items?.position || '-'}
                </Typography>
              </Box>
            </Box>
            <Box
              className={`d-flex flex-column align-items-center justify-content-center ${classes.linkBg}`}
              onClick={() => {
                window.open(items?.Linkedin_Profile_URL__c, '_blank');
              }}
              component={'div'}
            >
              <FiLink color="#FFFFFF" size={'8px'} />
            </Box>
          </Box>
        );
      })}
    </div>
  );
};

export default FounderTeam;
